import React from "react";
import { Box, Card } from "@bca/ui-library";
import { layout, LayoutProps } from "styled-system";
import styled from "styled-components";

import AnimatedBox from "./AnimatedBox";

const StyledCard = styled(Card)<LayoutProps>`
  ${layout}
`;

const DesktopSkeletonCard = ({
  display,
}: {
  display?: LayoutProps["display"];
}) => (
  <StyledCard
    width="100%"
    height="260px"
    paddingX={0}
    paddingY={0}
    marginX={0}
    marginY={0}
    display={display}
    data-testid="container"
  >
    <Box
      display="flex"
      flexDirection="row"
      justifyContent="space-between"
      width="auto"
      data-testid="container2"
    >
      <AnimatedBox
        width="260px"
        height="260px"
        data-testid="image-skel"
        borderTopRightRadius="0px"
        borderBottomRightRadius="0px"
      />
      <Box
        data-testid="middle-skel"
        display="flex"
        flexDirection="column"
        flex="1 0 auto"
        padding={4}
        mb="43px"
      >
        <AnimatedBox width="112px" height="23px" mb="43px" />
        <AnimatedBox width="365px" height="16px" mb="43px" />
        <Box display="flex" flexDirection="row" mb={6}>
          <Box>
            <AnimatedBox width="18px" height="18px" />
            <AnimatedBox width="80px" height="13px" my="9px" mr={7} />
          </Box>
          <Box>
            <AnimatedBox width="18px" height="18px" />
            <AnimatedBox width="80px" height="13px" my="9px" mr={7} />
          </Box>
          <Box>
            <AnimatedBox width="18px" height="18px" />
            <AnimatedBox width="80px" height="13px" my="9px" mr={7} />
          </Box>
          <Box>
            <AnimatedBox width="18px" height="18px" />
            <AnimatedBox width="80px" height="13px" my="9px" />
          </Box>
        </Box>
      </Box>
      <Box
        backgroundColor="rgba(190, 191, 190, 0.1)"
        padding={4}
        display="flex"
        alignItems="flex-end"
        width="180px"
        height="auto"
        data-testid="end-skel"
      ></Box>
    </Box>
  </StyledCard>
);

export default DesktopSkeletonCard;
